import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncRequestResetPasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "password-reset" */ './containers/RequestResetPasswordContainer'
    ),
  {},
  true,
);
const AsyncResetPasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "password-reset" */ './containers/ResetPasswordContainer'
    ),
  {},
  true,
);
const AsyncChangePasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "change-password" */ './containers/ChangePasswordContainer'
    ),
  {},
  true,
);
const AsyncActivateAccountContainer = Load(
  () =>
    import(
      /* webpackChunkName: "activate-account" */ './containers/ActivateAccountContainer'
    ),
  {},
  true,
);
const TokenLoginAccountContainer = Load(
  () =>
    import(
      /* webpackChunkName: "token-login" */ './containers/TokenLoginContainer'
    ),
  {},
  true,
);

const PasswordRoutes = [
  <Route
    key={'password'}
    path={`${basePath}/password`}
    component={AsyncChangePasswordContainer}
  />,
  <Route
    key={'password.reset.token'}
    path={`${basePath}/reset/:token`}
    component={AsyncResetPasswordContainer}
  />,
  <Route
    key={'password.reset'}
    path={`${basePath}/reset`}
    component={AsyncRequestResetPasswordContainer}
  />,
  <Route
    key={'password.activate'}
    path={`${basePath}/activate/:token`}
    component={AsyncActivateAccountContainer}
  />,
  <Route
    key={'token.login'}
    path={`${basePath}/token/:token`}
    component={TokenLoginAccountContainer}
  />,
];

export default PasswordRoutes;
